import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider, useAppState } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import RangeInput from "./elements/RangeInput";
import Icon from "./elements/Icon";

export default function RangeFacet({ facet, opened, setOpened }) {
  const { loading, query, response, pageType } = useAppState();
  const { min, max, range, updateRange } = useRangeSlider(facet.id);
  const isSelected = min !== range[0] || max !== range[1];
  const [active, setActive] = useState(false);
  let isMobile = window.innerWidth < 769;
  const isCategory = pageType == "category";

  useEffect(() => {
    if (isMobile) {
      setActive(false);
    }
  }, []);

  function handleClick(e) {
    if (
      e.target.closest(".ns-cat-sidebar-wrapper") &&
      window.innerWidth > 480
    ) {
      setActive(!active);
      setOpened(active ? null : facet.field);
    } else {
      setActive(!active);
    }
  }

  if (window.innerWidth > 480) {
    useEffect(() => {
      setActive(opened === facet.field);
    }, [opened, facet.field]);
  }

  return (
    <li
      class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}
      facet={facet.name}
      style={
        isMobile
          ? active
            ? { height: "auto" }
            : {}
          : active
          ? { height: "auto" }
          : {}
      }
    >
          <a
            class="ns-sidebar-title-box ns-filter-block-title ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
            href="javascript:void(0)"
            onClick={(e) => {
              handleClick(e);
            }}
          >
            <span class="ns-sidebar-title ns-cat-title">
              {facet.name}
              {isSelected && <span class="ns-sidebar-count">(1)</span>}
            </span>
            <i class="ns-icon ns-icon-arrow ns-absolute"></i>
          </a>
          <div
            class="ns-sidebar-range ns-sidebar-submenu ns-sidebar-submenu-list ns-d-none"
            style="max-height: 100px;"
          >
            <RangeSlider id={facet.id} />
          </div>
    </li>
  );
}
